import { Navigation, Pagination } from 'swiper';
import SwiperModule from './Slider';

class Top {
  constructor() {
    this.initVehicleSiwper();
    this.initSponsorSiwper();
    this.QuestionAnswer();
  }

  initVehicleSiwper() {
    const swiperContainer = document.querySelector('.vehicle__swiper');

    // Swiperのオプションを設定
    const swiperOptions = {
      modules: [Navigation, Pagination],
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
      },
    };

    // SwiperModuleのインスタンスを作成
    this.mySwiper = new SwiperModule(swiperContainer, swiperOptions);
  }

  initSponsorSiwper() {
    const swiperContainer = document.querySelector('.sponsor__swiper');

    // Swiperのオプションを設定
    const swiperOptions = {
      modules: [Pagination],
      pagination: {
        el: '.swiper-pagination',
      },
    };

    // SwiperModuleのインスタンスを作成
    this.mySwiper = new SwiperModule(swiperContainer, swiperOptions);
  }

  // Questionのプルダウン
  QuestionAnswer() {
    const question = document.querySelectorAll('.faq__qContainer');
    const plus = question.forEach((q) =>
      q.addEventListener('click', function () {
        this.nextElementSibling.classList.toggle('isShow');
        this.lastElementChild.lastElementChild.classList.toggle('rotate');
      })
    );
  }
}
export default Top;
